import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import ModalComponent from "../../../components/modals/ModalComponent";
import { SendOrganizerPdfApi } from "../../../api/request/taskManager/taskManager";
import ClouldUpload from "../../../assets/ClouldUpload";

const OrganizerPdfModal = ({
  isOpen = false,
  setIsOpen,
  isSpouse = false,
  clientData = {},
  organizerId = 0,
}) => {
  const [selectedFor, setSelectedFor] = useState("user");
  const [file, setFile] = useState(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const fileInputRef = useRef(null);
  const showSpouseTab = isSpouse === true || Number(isSpouse) === 1;

  useEffect(() => {
    if (!isOpen) {
      setSelectedFor("user");
      setFile(null);
      setIsDragOver(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && !showSpouseTab && selectedFor !== "user") {
      setSelectedFor("user");
    }
  }, [isOpen, showSpouseTab, selectedFor]);

  const handleClose = () => {
    setIsOpen(false);
  };

  const isPdfFile = (candidate) => {
    if (!candidate) return false;
    if (candidate.type === "application/pdf") return true;
    return candidate.name?.toLowerCase().endsWith(".pdf");
  };

  const setPdfFile = (candidate) => {
    if (!candidate) return;
    if (!isPdfFile(candidate)) {
      toast.error("Only PDF files are allowed.");
      return;
    }
    setFile(candidate);
  };

  const handleChooseClick = () => {
    fileInputRef.current?.click();
  };

  const handleInputChange = (e) => {
    const picked = e.target.files?.[0];
    setPdfFile(picked);
    e.target.value = "";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const dropped = e.dataTransfer.files?.[0];
    setPdfFile(dropped);
  };

  const handleSubmit = async () => {
    if (!file) {
      toast.error("Please choose a PDF file.");
      return;
    }
    // if (onSubmit) {
    //   await onSubmit({ file, selectedFor });
    //   return;
    // }
    try {
      setIsSubmitLoading(true);
      const apiHeader = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      const params = {
        organizer_id: organizerId || clientData?.id || 0,
        file,
        user_type: selectedFor,
      };
      const { data } = await SendOrganizerPdfApi(params, apiHeader);
      if (data?.status) {
        toast.success(data?.message);
        handleClose();
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      width={640}
      closable={false}
    >
      <div>
        <div className="flex items-center justify-between">
          <p className="text-xl text-[#2F2B3D] font-semibold">
            Upload PDF for sign
          </p>
          <button
            type="button"
            onClick={handleClose}
            className="p-1 rounded-md hover:bg-black/5"
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#2F2B3D"
              className="w-5 h-5"
            >
              <path
                fillRule="evenodd"
                d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>

        <div className="flex justify-center mt-5">
          <div
            className={`border border-[#E5E7EB] bg-[#F9FAFB] rounded-lg p-1 ${
              showSpouseTab ? "flex gap-1 w-full max-w-[320px]" : "inline-flex"
            }`}
          >
            <button
              type="button"
              onClick={() => setSelectedFor("user")}
              className={`${
                showSpouseTab ? "w-1/2" : "px-6"
              } py-2 rounded-md text-sm font-semibold transition-colors ${
                selectedFor === "user"
                  ? "bg-primary text-white"
                  : "bg-white text-[#2F2B3D]"
              }`}
            >
              For Client
            </button>
            {showSpouseTab ? (
              <button
                type="button"
                onClick={() => setSelectedFor("spouse")}
                className={`w-1/2 py-2 rounded-md text-sm font-semibold transition-colors ${
                  selectedFor === "spouse"
                    ? "bg-primary text-white"
                    : "bg-white text-[#2F2B3D]"
                }`}
              >
                For Spouse
              </button>
            ) : null}
          </div>
        </div>

        <input
          ref={fileInputRef}
          type="file"
          accept="application/pdf"
          className="hidden"
          onChange={handleInputChange}
        />

        <div
          className={`mt-6 border border-dashed rounded-xl px-6 py-3 flex flex-col items-center text-center transition-colors cursor-pointer ${
            isDragOver ? "border-primary bg-primary/5" : "border-[#E5E7EB]"
          }`}
          onDragOver={(e) => {
            e.preventDefault();
            setIsDragOver(true);
          }}
          onDragLeave={() => setIsDragOver(false)}
          onDrop={handleDrop}
          onClick={handleChooseClick}
        >
          <div>
            <ClouldUpload color="#D32E2E" />
          </div>
          <p className="mt-2 text-lg font-semibold text-[#2F2B3D]">
            Upload PDF File
          </p>
          <p className="mt-1 text-sm text-[#2F2B3D99]">
            Only PDF files are allowed.
          </p>

          {file?.name && (
            <p className="mt-3 text-sm text-[#2F2B3D] font-medium max-w-[420px] truncate">
              {file.name}
            </p>
          )}

          <div
            // onClick={handleChooseClick}
            className="font-semibold rounded-md mt-2"
          >
            Choose PDF File
          </div>
        </div>

        <div className="mt-8 flex justify-end gap-3">
          <button
            type="button"
            onClick={handleSubmit}
            disabled={!file || isSubmitLoading}
            className="bg-primary text-white font-semibold px-10 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitLoading ? "Submitting..." : "Submit"}
          </button>
          <button
            type="button"
            onClick={handleClose}
            className="border border-primary text-primary font-semibold px-10 py-2 rounded-md"
          >
            Cancel
          </button>
        </div>
      </div>
    </ModalComponent>
  );
};

export default OrganizerPdfModal;
